import React, { useEffect, useState } from 'react'
import defaultClasses from './heroItemsWrapper.module.scss'
import { string } from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useDeviceType } from '@components/common/IsMobile/useDeviceType'

const HeroItemsWrapper = (props) => {
    const { offsetTop, children } = props
    const { isMobile, isTablet } = useDeviceType()

    const bannerWrapper = {
        position: 'relative',
        top: offsetTop
    }

    return (
        <div className={defaultClasses['hero-items-wrapper-main']}>
            <div
                className={defaultClasses['hero-items-wrapper']}
                style={bannerWrapper}
            >
                {isMobile || isTablet ? (
                    <PerfectScrollbar>
                        <div
                            className={
                                defaultClasses['hero-items-mobile-wrapper']
                            }
                        >
                            {children}
                        </div>
                    </PerfectScrollbar>
                ) : (
                    children
                )}
            </div>
        </div>
    )
}

HeroItemsWrapper.propTypes = {
    offsetTop: string
}

export default HeroItemsWrapper
